import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductosSubDestinosMontos} from '../_models/producto-subdestino-monto';
import {ProductoSubdestinoMontoAliado} from '../_models/producto-subdestino-monto-aliado';

@Injectable({
  providedIn: 'root'
})
export class ProductoSubdestinoMontoAliadoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosSubDestinosMontosAliados';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoSubdestinoMontoAliado[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoSubdestinoMontoAliado[] ) );
  }

  listadoPorDestino( idProductoDestino: string ) {
    return this.httClient.get( this.rutServicio + '/productoMontoAliado/' + idProductoDestino ).pipe( map( res => res as ProductoSubdestinoMontoAliado[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoSubdestinoMontoAliado ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoSubdestinoMontoAliado[] ) );
  }

  listadoPorProductoDestino( idProducto: string, idProductoDestino: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto + '/destinoProducto/' + idProductoDestino + '/enabled' ).pipe( map( res => res as ProductoSubdestinoMontoAliado[] ) );
  }

  crear( regCrear: ProductoSubdestinoMontoAliado ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoSubdestinoMontoAliado ) );
  }

  actualizar( regActualizar: ProductoSubdestinoMontoAliado ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: ProductoSubdestinoMontoAliado[] ) {
    regActualizar.map( ( s: ProductoSubdestinoMontoAliado ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }
}
